import React from "react";
import { CONFIG } from "../config";
import { Reveal } from "../hooks/useReveal";

const ROWS = [
  { label: "Asset Representation", value: "10 mg Platinum / XPTY" },
  { label: "Blockchain", value: "Solana" },
  { label: "Backing", value: "100% Reserve-Backed" },
];

export default function Transparency() {
  return (
    <section id="transparency" className="w-full py-[80px] lg:py-[160px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="micro-label">Transparency</span>
              <h2 className="mt-5 text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
                Clear information.
                <br />
                <span className="text-[#B5BAB7]">No black box.</span>
              </h2>
              <div className="mt-10 border-t hairline pt-8">
                <div className="text-[22px] sm:text-[26px] font-medium text-[#F1F2EF] tracking-tight">
                  1 {CONFIG.token} = 10 mg Platinum
                </div>
                <p className="mt-4 text-[15px] leading-[1.6] text-[#A0A5A2] max-w-[420px]">
                  {CONFIG.token} is defined around a precise Platinum representation
                  and transparent blockchain infrastructure.
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.08}>
              <div className="border-t hairline">
                {ROWS.map((r) => (
                  <div
                    key={r.label}
                    className="flex items-center justify-between gap-6 py-5 border-b hairline"
                  >
                    <span className="text-[13px] sm:text-[14px] text-[#A0A5A2]">
                      {r.label}
                    </span>
                    <span
                      className={`text-[13px] sm:text-[15px] font-medium text-right ${
                        r.muted ? "text-[#6D726F]" : "text-[#F1F2EF]"
                      }`}
                    >
                      {r.value}
                    </span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
